export const redirects = {
  protectedRoute: '/calculator',
  unprotectedRoute: '/',
};
